'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dAccount$002dUsers$002dPage$0024 from "./presto.-List-Account-Users-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002473 from "./presto.-Presto-Router$$anon$73.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dAccount$002dName$0024 from "./presto.types$-Account-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$72() {
  this.bmH = null;
  this.bmz = null;
  this.bmA = false;
  this.bmI = null;
  this.bmJ = false;
  this.bmM = null;
  this.bmF = null;
  this.bmG = false;
  this.bmB = null;
  this.bmC = false;
  this.bmD = null;
  this.bmE = false;
  this.bmK = false;
  this.bmL = false;
  this.bmH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bmM = "ListAccountUsersPage";
}
export { $c_Lpresto_PrestoRouter$$anon$72 as $c_Lpresto_PrestoRouter$$anon$72 };
$p = $c_Lpresto_PrestoRouter$$anon$72.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$72;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$72() {
}
export { $h_Lpresto_PrestoRouter$$anon$72 as $h_Lpresto_PrestoRouter$$anon$72 };
$h_Lpresto_PrestoRouter$$anon$72.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bmH;
});
$p.L = (function() {
  if ((!this.bmA)) {
    this.bmz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bmA = true;
  }
  return this.bmz;
});
$p.O = (function() {
  if ((!this.bmJ)) {
    this.bmI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bmJ = true;
  }
  return this.bmI;
});
$p.E = (function() {
  return this.bmM;
});
$p.t = (function() {
  if ((!this.bmG)) {
    this.bmF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bmG = true;
  }
  return this.bmF;
});
$p.M = (function() {
  if ((!this.bmC)) {
    this.bmB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dName$0024.$m_Lpresto_types$AccountName$().ads(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bmC = true;
  }
  return this.bmB;
});
$p.Q = (function() {
  if ((!this.bmE)) {
    this.bmD = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002473.$c_Lpresto_PrestoRouter$$anon$73();
    this.bmE = true;
  }
  return this.bmD;
});
$p.w = (function() {
  if ((!this.bmL)) {
    this.bmK = false;
    this.bmL = true;
  }
  return this.bmK;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee507) => ((p) => \u03b4scrutinee507.cGc(p)))($j_presto$002e$002dList$002dAccount$002dUsers$002dPage$0024.$m_Lpresto_ListAccountUsersPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$72 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$72, "presto.PrestoRouter$$anon$72", ({
  OG: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$72 as $d_Lpresto_PrestoRouter$$anon$72 };
//# sourceMappingURL=presto.-Presto-Router$$anon$72.js.map
